const select = {
    state: {
        
    },
    mutations: {
        
    },
    actions: {
        
    }
}
export default select